import script from "./ViewEmployeeDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewEmployeeDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ViewEmployeeDetails.vue?vue&type=style&index=0&id=75f09a59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f09a59"]])

export default __exports__